import React from 'react';
import classNames from 'classnames';

import { Icon } from 'js/components';

import styles from './SentimentMarker.module.scss';

/**
 * FontAwesome's layer transforms assume a 512-wide canvas. Icons like
 * `face-nose-steam` (576 wide) therefore shrink around the wrong origin and
 * sit off-center on the circle. This marker sizes the circle in `em`s and
 * CSS-centers the glyph on it, so viewBox width does not matter.
 *
 * `shrink` is FontAwesome's unit: each step is 1/16 of the canvas, so the
 * default 8 matches thumbs on a stacked circle; faces pass 6.
 */
function iconAspect(icon) {
  const canvas = icon?.icon;
  if (Array.isArray(canvas) && canvas[0] && canvas[1]) {
    return canvas[0] / canvas[1];
  }
  return 1;
}

export default function SentimentMarker({
  icon,
  rotate = 0,
  shrink = 8,
  inverse = true,
  colorOnly = false,
  className,
  style,
}) {
  const scale = 1 - shrink / 16;
  const showGlyph = Boolean(icon) && !colorOnly;

  return (
    <span
      className={classNames(styles.marker, className, {
        [styles.colorOnly]: colorOnly,
      })}
      style={{
        ...style,
        '--glyph-rotate': `${Math.round(rotate) || 0}deg`,
        '--glyph-scale': scale,
        '--glyph-aspect': iconAspect(icon),
      }}
    >
      <Icon
        icon="circle"
        className={styles.circle}
        style={{ width: '1em', height: '1em' }}
      />
      {showGlyph ? (
        <Icon
          icon={icon}
          inverse={inverse}
          className={styles.glyph}
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: `calc(1em * ${scale} * ${iconAspect(icon)})`,
            height: `calc(1em * ${scale})`,
            transform: `translate(-50%, -50%) rotate(${
              Math.round(rotate) || 0
            }deg)`,
          }}
        />
      ) : null}
    </span>
  );
}
